<template>
  <div>
    <ViewTemplateWithSalveCancel :panel="panel">
      <div slot="content-buttons">
        <Button v-if="id" _key="btnBankAccountCreate" title="Conta Bancária" classIcon="fas fa-plus-circle"
          type="primary" size="small" :clicked="create" />
      </div>
      <div slot="content-main">
        <BankAccountCreateUpdate />
      </div>
      <Button slot="save-buttons" _key="saveAndCloseSaveCancel" title="Salvar e Fechar"
        classIcon="fa-solid fa-floppy-disk-circle-arrow-right" type="primary" size="medium"
        :disabled="!isFormValid(panel.formName)" eventName="saveAndCloseSaveCancel" />
    </ViewTemplateWithSalveCancel>
  </div>
</template>

<script>
import ViewTemplateWithSalveCancel from "@/ui/template/ViewTemplateWithSalveCancel";
import BankAccountCreateUpdate from "../components/bankAccount/BankAccountCreateUpdate.vue";

import Button from "@/ui/forms/Button";

import { mapMutations, mapGetters } from "vuex";

export default {
  name: "BankAccountCreateUpdateView",
  components: {
    Button,
    ViewTemplateWithSalveCancel,
    BankAccountCreateUpdate,
  },
  data() {
    return {
      id: this.$route.params.id,
      panel: {
        module: "Financeiro",
        title: "Conta Bancária",
        formName: "bankAccountCreateUpdate",
        showFilter: false,
        showSearch: false,
        showButtons: true,
      },
    };
  },
  computed: {
    ...mapGetters("validation", ["isFormValid"]),
  },
  methods: {
    ...mapMutations("generic", ["removeLoading"]),
    create() {
      this.$router.push({
        name: "bankAccountCreateNew",
      });
      this.removeLoading(["btnBankAccountCreate"]);
    },
  },
};
</script>
